
import { supabase } from "@/integrations/supabase/client";
import { logClaudeApiInteraction } from "../logging/claudeApiLogger";

/**
 * Calculate proximity score between two words using Claude
 */
export const calculateProximityScore = async (userWord: string, botWord: string, gameId?: string, roundNumber?: number): Promise<number> => {
  const startTime = Date.now();
  console.log(`Requesting proximity score for "${userWord}" and "${botWord}"`);
  
  // Prepare input for logging
  const input = { userWord, botWord };
  
  try {
    const response = await supabase.functions.invoke('calculate-proximity', {
      body: input
    });
    
    if (response.error) {
      console.error("Proximity calculation error:", response.error);
      
      // Log error response (the Edge Function might not have logged this error)
      await logClaudeApiInteraction(
        gameId || null,
        roundNumber || null,
        'proximity',
        input,
        null,
        response.error,
        response.error.status || 500,
        startTime,
        true,
        `Proximity calculation failed: ${response.error.message || 'Unknown error'}`
      );
      
      throw new Error(`Proximity calculation failed: ${response.error.message || 'Unknown error'}`);
    }
    
    const proximityScore = response.data?.proximityScore;
    
    if (typeof proximityScore !== 'number') {
      const error = new Error(`Invalid proximity score format: ${JSON.stringify(proximityScore)}`);
      console.error("Invalid proximity score format:", proximityScore);
      
      // Log invalid response
      await logClaudeApiInteraction(
        gameId || null,
        roundNumber || null,
        'proximity',
        input,
        response.data,
        error,
        400,
        startTime,
        true,
        "Invalid proximity score format in response"
      );
      
      throw error;
    }
    
    // Don't log successful responses - the Edge Function already did this
    return proximityScore;
  } catch (error) {
    console.error("Error calculating proximity:", error);
    
    // Only log errors that weren't already logged
    if (!(error instanceof Error && error.message.includes('Proximity calculation failed'))) {
      await logClaudeApiInteraction(
        gameId || null,
        roundNumber || null,
        'proximity',
        input,
        null,
        error,
        500,
        startTime,
        true,
        `Unhandled error: ${error instanceof Error ? error.message : 'Unknown error'}`
      );
    }
    
    throw error; // Re-throw for retry logic
  }
};
